module.exports = __webpack_public_path__ + "static/media/mgm_large.b2dab524.jpg";